import React from 'react';

const InnerDetails = ({searchDetails, events, colSpan = 6}) => {
    if (!searchDetails || !events.length) return null;

    return (
        <tr>
            <td colSpan={colSpan} className="p-4">
                <table className="table w-full">
                    <thead>
                        <tr className="text-left">
                            <th colSpan={2}>D/H de início</th>
                            <th colSpan={2}>D/H de fim</th>
                            <th colSpan={2} className="text-right">Duração do evento</th>
                        </tr>
                    </thead>

                    <tbody>
                        { events.map((event, index) => (
                            <tr key={index}>
                                <td colSpan={2}>
                                    {event.dt_begin_formatted ?? 'Sem data'}
                                </td>
                                <td colSpan={2}>
                                    {event.dt_end_formatted ?? 'Sem data'}
                                </td>
                                <td colSpan={2} className="text-right">
                                    {event.duration}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default InnerDetails;